import { React, useState } from "react";
import { Container } from "@mantine/core";
import { ActionIcon, Group } from "@mantine/core";
import { IconPlayerPlay } from "@tabler/icons-react";
import "./VideoPlayer.scss";
import Vimeo from "@u-wave/react-vimeo";

export const VideoPlayer = (props) => {
  const [isPlaying, setVideoPlaying] = useState(false);

  const handleClick = () => {
    setVideoPlaying(true);
    window.dataLayer.push({ event: "video_loaded" });
  };

  return (
    <>
    {!isPlaying ? (
        <Container h={props.h} p={props.p} className={props.reviewClass ? props.reviewClass : props.videoModal ? "player-wrapper" : "wrapper"} onClick={() => handleClick()}>
          <Vimeo
            video={props.video_url}
            className={props.reviewClass ? "react-player review": "react-player"}
            controls={false}
            showTitle={false}
            responsive={true}
            autoplay={false}
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              cursor: "pointer",
            }}
          >
            <Group justify="center" align="center">
              <ActionIcon
                onClick={() => {
                  handleClick();
                }}
                variant="default"
                size="xl"
                aria-label="Toggle color scheme"
              >
                <IconPlayerPlay stroke={1.5} />
              </ActionIcon>
            </Group>
          </div>
          </Container>
      ) : (
        <Container h={props.h} mt={props.mt} ml={0} mr={0} pl={0} pr={0} pt={props.p} pb={props.p} className={props.reviewClass ? props.reviewClass : props.videoModal ? "player-wrapper" : "wrapper"}>
          <Container>
            <Vimeo
              video={props.video_url}
              className={props.reviewClass ? "react-player review": "react-player"}
              controls={true}
              autoplay={true}
              showTitle={false}
              responsive={true}
              loop={false}
              paused={true}
            />
          </Container>
        </Container>
      )}     
    </>
  );
};
